export const ja = {
  dashboard: 'ダッシュボード',
  location: '位置情報',
  photos: '写真一覧',
  history: '日記',
  settings: '設定',
  connected: '接続中',
  connecting: '接続中',
  disconnected: '未接続',
  error: 'エラー',
  reconnect: '再接続',
  photoData: '写真データ',
  audioData: '音声データ',
  gpsData: 'GPSデータ',
  realtimeData: 'リアルタイムデータ',
  waitingForData: 'データを待機中...',
  persons: '人物',
  gpsDataList: 'GPSデータ一覧',
  waitingForGps: 'GPSデータを待機中...',
  diaryHistory: '日記履歴',
  underDevelopment: '機能は開発中です'
};
